import React, { useEffect, useRef } from 'react';

export default function MembershipBadge({ tier }) {
  const badgeRef = useRef(null);

  useEffect(() => {
    if (tier !== 'insider') return;
    const el = badgeRef.current;
    if (!el) return;
    const interval = setInterval(() => {
      const p = document.createElement('div');
      p.className = 'insider-particle';
      const dx = (Math.random() - 0.5) * 36;
      const dy = -(Math.random() * 40 + 10);
      p.style.setProperty('--dx', dx + 'px');
      p.style.setProperty('--dy', dy + 'px');
      p.style.left = (25 + Math.random() * 30) + 'px';
      p.style.top = (10 + Math.random() * 40) + 'px';
      p.style.width = (1 + Math.random() * 2) + 'px';
      p.style.height = p.style.width;
      el.appendChild(p);
      setTimeout(() => p.remove(), 1500);
    }, 40);
    return () => clearInterval(interval);
  }, [tier]);

  if (!tier || tier === 'explorer') return null;

  const config = {
    member: { icon: '🛡️', label: 'Member' },
    enthusiast: { icon: '🔥', label: 'Enthusiast' },
    insider: { icon: '⭐', label: 'Insider' },
  };

  const c = config[tier];
  if (!c) return null;

  return (
    <div className={`membership-badge badge-tier-${tier}`} ref={badgeRef}>
      <div className="membership-badge-ring">
        <div className="membership-badge-inner">{c.icon}</div>
      </div>
      <div className="membership-badge-label">{c.label}</div>
    </div>
  );
}
